module.exports = __webpack_public_path__ + "static/media/autochilango-vial.d5e98aab.svg";